import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { Box } from '../Box/Box';
export var listItemEndMediaClassName = 'ui-list__itemendmedia';

/**
 * Provides a header media for the ListItem.
 */
export var ListItemEndMedia = /*#__PURE__*/function () {
  var ListItemEndMedia = compose(Box, {
    className: listItemEndMediaClassName,
    displayName: 'ListItemEndMedia',
    mapPropsToStylesProps: function mapPropsToStylesProps(_ref) {
      var navigable = _ref.navigable,
        selectable = _ref.selectable;
      return {
        navigable: navigable,
        selectable: selectable
      };
    },
    handledProps: ['navigable', 'selectable'],
    overrideStyles: true,
    shorthandConfig: {
      mappedProp: 'content'
    }
  });
  ListItemEndMedia.propTypes = commonPropTypes.createCommon();
  return ListItemEndMedia;
}();
//# sourceMappingURL=ListItemEndMedia.js.map
